import { Language } from './../services/languages/languages.service';
import {InjectionToken} from '@angular/core';

export const APP_LANGUAGES = new InjectionToken<Language[]>('APP_LANGUAGES');
